<template>
    <div class="row">
        <div class="col-md-6 col-xl-4">
            <div class="card mb-4">
                <h6 class="card-header">
                    Corrective Action Details

                    <span class="pull-right">
                    <router-link :to="`/corrective-actions/complete/${corrective_action_id}`" class="btn btn-xs btn-success">
                        <i class="fa fa-check-square"></i> Mark Completed
                    </router-link>
                    <router-link :to="`/corrective-actions/edit/${corrective_action_id}`" class="btn btn-xs btn-secondary">
                        <i class="fa fa-edit"></i> Edit
                    </router-link>
                    <router-link :to="`/corrective-actions/delete/${corrective_action_id}`" class="btn btn-xs btn-danger">
                        <i class="fa fa-trash"></i> Delete
                    </router-link>
                    </span>

                    <!-- @if($action->assignee_id == \Auth::id() && in_array($action->status_context, [\App\Status::Open, \App\Status::InProgress]))
                    <div class="form-group" style="margin-top: 10px;">
                        <a href="/correctiveActions/complete/{!! $action->corrective_action_id !!}" class="btn btn-default ca-btn-completed"><i class="fa fa-check-square"></i> Mark Completed</a>
                    </div>
                    @endif
                    @if($action->creator_id == Auth::id() || \Auth::user()->hasPermission('correctiveActions.manage'))
                    <div class="form-group" style="margin-top: 10px;">
                        <a href="/correctiveActions/edit/{!! $action->corrective_action_id !!}" class="btn btn-default ca-btn-completed"><i class="fa fa-edit"></i> Edit</a>
                    </div>
                    <div class="form-group" style="margin-top: 10px;">
                        <a href="/correctiveActions/delete/{!! $action->corrective_action_id !!}" class="btn btn-default ca-btn-completed"><i class="fa fa-trash"></i> Delete</a>
                    </div>
                    @endif -->
                </h6>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <div class="text-muted">Status</div>
                        <span class="ca-status">
                            <label :class="`badge badge-${action.status_id ? action.status_color : ''}`">
                                {{ action.status_id ? action.status_name : '--' }}
                            </label>
                        </span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <div class="text-muted">Source</div>
                        <div>{{ action.corrective_source_id ? action.source_name : '' }}</div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <div class="text-muted">Location</div>
                        <div>{{ action.location }}</div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <div class="text-muted">Created By</div>
                        <div><user-name :user="creator" /></div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <div class="text-muted">Assigned To</div>
                        <div><user-name :user="assignee" /></div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <div class="text-muted">Subcontractor</div>
                        <div>{{ action.subcontractor }}</div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <div class="text-muted">Completed By</div>
                        <div><user-name :user="completer" /></div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <div class="text-muted">Created Date</div>
                        <div><span class="ca-completed-at">{{ action.created_at_formatted }}</span></div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <div class="text-muted">Due Date</div>
                        <div><span class="ca-completion-time">{{ action.due_date }}</span></div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <div class="text-muted">Completed Date</div>
                        <div><span class="ca-completion-time">{{ action.completed_at_formatted }}</span></div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <div class="text-muted">Time to Completion</div>
                        <div><span class="ca-completion-time">{{ action.time_to_completion }}</span></div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-md-6 col-xl-4">
            <div class="card mb-4">
                <h6 class="card-header">
                    Details
                </h6>
                <div class="list-group-item">
                    {{ action.detail }}
                </div>
            </div>
        </div>
        <div class="col-md-6 col-xl-4">
            <div class="card mb-4">
                <h6 class="card-header">
                    Completed Comment
                </h6>
                <div class="list-group-item">
                    <span class="ca-completed-comment">{{ action.completed_detail }}</span>
                </div>
            </div>
        </div>
        <div class="col-md-12 col-xl-4">
            <div class="card mb-4">
                <h6 class="card-header">
                    Corrective Action Files &amp; Photos
                </h6>
                <div>
                    <file-list :files="files" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            corrective_action_id: {
                type: String,
                required: true
            },
            action: {
                type: Object,
                required: true
            },
            files: {
                type: Array,
                required: true
            }
        },

        computed: {
            assignee() {
                return {
                    FirstName: this.action.assignee_first_name,
                    LastName: this.action.assignee_last_name,
                    deleted_at: this.action.assignee_deleted_at,
                };
            },

            creator() {
                return {
                    FirstName: this.action.creator_first_name,
                    LastName: this.action.creator_last_name,
                    deleted_at: this.action.creator_deleted_at,
                };
            },

            completer() {
                return {
                    FirstName: this.action.completer_first_name,
                    LastName: this.action.completer_last_name,
                    deleted_at: this.action.completer_deleted_at,
                };
            },
        },

        methods: {

        },
    }
</script>
